

import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class StepNumber extends Vue {

    @Prop({required: true})
    stepNumber!: number;

    @Prop({required: true})
    active!: boolean;

    @Prop({required: false})
    stepStyle!: string;  

    iconActiveClass = "fa fa-circle-thin text-dark fa-stack-2x"
    numberActiveClass = "fa-stack-1x text-dark"

    iconInActiveClass = "fa fa-circle-thin text-inactive fa-stack-2x"
    numberInActiveClass = "fa-stack-1x text-inactive"

}

